/**
 * Centralized fraction compound key utilities.
 *
 * Fraction widgets use compound keys (e.g., "x__num", "x__den") in the
 * UI values map for sub-inputs. These keys are UI-only — they never appear
 * in the widgets map or validation answers.
 */

export type FractionPart = 'num' | 'den';

export function getFractionKey(widgetId: string, part: FractionPart): string {
  return `${widgetId}__${part}`;
}

export function isFractionKey(key: string): boolean {
  return key.endsWith('__num') || key.endsWith('__den');
}

export function parseFractionKey(key: string): { widgetId: string; part: FractionPart } | null {
  const match = key.match(/^(.+)__(num|den)$/);
  if (!match) return null;
  return { widgetId: match[1]!, part: match[2] as FractionPart };
}
